import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

const SingleShgMemberPage = () => {
  const { memberId } = useParams();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;
  const [shg, setShg] = useState();

  const fetchMemberDetails = async () => {
    setLoading(true);
    try {
      const config = Authorization();
      const response = await axios.get(
        `${Api}/api/members/getMemberLoanDetails/${memberId}`,
        config
      );

      setMember(response.data.member);
      setLoans(response.data.loans || []);
      setShg(response.data.shg);
    } catch (error) {
      console.error("Failed to fetch member data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMemberDetails();
  }, [memberId]);

  if (loading) return <Preloader loading={true} />;

  if (!member)
    return (
      <div className="text-danger text-center mt-5">
        Member not found or access denied.
      </div>
    );

  return (
    <div>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center mb-3 px-2">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              setLoading(true);
              fetchMemberDetails();
            }}
          >
            🔄 Refresh Now
          </button>
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
          </ol>
        </nav>
      </div>
      <div className="card bg-gradient-success card-img-holder text-white mb-4">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />
          <h4 className="font-weight-normal mb-3">SHG - {shg.name}</h4>
          <h3 className="font-weight-bold">{member?.name || "Loading..."}</h3>
        </div>
      </div>

      <div className="card p-4 mb-4">
        <h5 className="mb-3">Member Information</h5>
        <div className="row">
          {/* Column 1 */}
          <div className="col-md-4">
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Name</span>
              <span style={{ width: "5px", textAlign: "center" }}>-</span>
              <span>{member.name || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Code</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.memberCode || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Gender</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.gender || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                Community
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.community || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                Educational Qualification
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.educationalQualification || "N/A"}</span>
            </p>
          </div>

          {/* Column 2 */}
          <div className="col-md-4">
            <p className="d-flex align-items-center">
              <span style={{ width: "160px", fontWeight: "600" }}>
                Father/Husband
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.fatherOrHusband || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "160px", fontWeight: "600" }}>
                Father/Husband Name
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.fatherOrHusbandName || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Work</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.work || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                Marital Status
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.maritialStatus || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Phone</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.phone || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Email</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.eMail || "N/A"} </span>
            </p>
          </div>

          {/* Column 3 */}
          <div className="col-md-4">
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Address</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.address || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Village</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.village || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                Panchayath
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.panchayath || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Thaluk</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.thaluk || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                District
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.district || "N/A"}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                Pin Code
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.pinCode || "N/A"}</span>
            </p>
          </div>
        </div>

        <hr />
        <h6 className="mb-3">Bank Details</h6>
        <div className="row">
          <div className="col-md-4">
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Bank</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.bank}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Branch</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.branch}</span>
            </p>
          </div>
          <div className="col-md-4">
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                Account Number
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.accountNumber}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                IFSC Code
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.ifscCode}</span>
            </p>
          </div>
          <div className="col-md-4">
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>
                Ration Card
              </span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.rationCard}</span>
            </p>
            <p className="d-flex align-items-center">
              <span style={{ width: "100px", fontWeight: "600" }}>Aadhar</span>
              <span style={{ width: "10px", textAlign: "center" }}>-</span>
              <span>{member.aadhar}</span>
            </p>
          </div>
        </div>

        <hr />
        <h6 className="mb-3">Family</h6>
        <p className="d-flex align-items-center">
          <span style={{ width: "160px", fontWeight: "600" }}>
            Family Member Details
          </span>
          <span style={{ width: "10px", textAlign: "center" }}>-</span>
          <span>{member.familyMemberDetails}</span>
        </p>
      </div>

      <div className="card p-4">
        <h5 className="mb-3">Loan Details</h5>
        {loans.length === 0 ? (
          <p>No loans found for this member.</p>
        ) : (
          <>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={loans.map((loan) => ({
                  _id: loan._id,
                  disbursedAmount: loan.subLoans.reduce(
                    (sum, sub) => sum + sub.disbursedAmount,
                    0
                  ),
                }))}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="_id" tick={false} />
                <YAxis />
                <Tooltip />
                <Bar
                  dataKey="disbursedAmount"
                  fill="#8884d8"
                  name="Total Loan"
                />
              </BarChart>
            </ResponsiveContainer>

            <div className="mt-4">
              {loans.map((loan, index) => (
                <div key={index} className="mb-4 border-bottom pb-3">
                  <p>
                    <strong>Loan ID:</strong> {loan._id}
                  </p>
                  <p>
                    <strong>Total Loan Amount:</strong> ₹
                    {loan.subLoans.reduce(
                      (sum, sub) => sum + (sub.disbursedAmount || 0),
                      0
                    )}
                  </p>

                  {loan.subLoans.map((subLoan, subIndex) => (
                    <div key={subIndex} className="ms-3 mb-2">
                      <p>
                        <strong>Subloan ID:</strong> {subLoan.subLoanId}
                      </p>
                      <p>
                        <strong>Disbursed Amount:</strong> ₹
                        {subLoan.disbursedAmount}
                      </p>
                      {subLoan.issuedDate && (
                        <p>
                          <strong>Issued On:</strong>{" "}
                          {new Date(subLoan.issuedDate).toLocaleDateString()}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SingleShgMemberPage;
